import { Check } from "lucide-react";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  labels?: string[];
}

/**
 * Step indicator atom.
 * 30 px circles: completed = secondary-120 bg + check icon,
 * active = secondary-120 bg + number, inactive = neutral-100 bg + number.
 * Connecting lines change color based on step progression.
 */
export function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  return (
    <div className="flex items-center gap-0">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;
        const isPast = step <= currentStep;

        return (
          <div key={step} className="flex items-center">
            {/* Circle */}
            <div
              className={`flex items-center justify-center rounded-full font-bold ${
                isPast
                  ? "bg-secondary-120 text-black"
                  : "bg-neutral-100 text-black"
              }`}
              style={{ width: 30, height: 30, fontSize: 14 }}
            >
              {isCompleted ? (
                <Check size={14} strokeWidth={3} />
              ) : (
                <span className={isActive ? "font-bold" : "font-semibold"}>
                  {step}
                </span>
              )}
            </div>

            {/* Connector line */}
            {step < totalSteps && (
              <div
                className={
                  step < currentStep ? "bg-secondary-120" : "bg-neutral-100"
                }
                style={{ width: 30, height: 1 }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
